import React, { useState, useEffect } from "react";
import MasterPage from "../Templates/MasterPage";
import Footer from "../Templates/Footer";
import { Autocomplete, useLoadScript } from "@react-google-maps/api";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import Swal from "sweetalert2";
import { server } from "../server";
import {  setKey,  setDefaults,  fromLatLng,  setLocationType,  RequestType,} from "react-geocode";
import { Link, useNavigate, useLocation } from "react-router-dom";
// import { Company_Id() } from "../Helper";
// import { Corporate_Id() } from "../Helper";
// import { Corporate_Name() } from "../Helper";
// import { Vendor_Id() } from "../Helper";
// import { Vendor_Name() } from "../Helper";
import axios from "axios";
// import React, { useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaTrashAlt } from "react-icons/fa";
import { de } from "date-fns/locale";
import { act } from "react";
import { Company_Id, Corporate_Id, Vendor_Id,Corporate_Name,Vendor_Name } from "../Helper";


const placesLibrary = ["places"];
function Booking() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("myself");
  const [AirportLatitude, setAirportLatitude] = useState("");
  const [AirportLongitude, setAirportLongitude] = useState("");
  const [contactNo, setContactNo] = useState("");
  let userId = localStorage.getItem("userid");
  let userMobNo = localStorage.getItem("contactNo");
  let userName = localStorage.getItem("EmployeeName");
  let userEmailId = localStorage.getItem("emailId");
  let JWTToken = localStorage.getItem("Token");
  let IsHideAirport = localStorage.getItem("IsHideAirport");
 const [email, setEmail] = useState("");
 const [displayRazorpay, setDisplayRazorpay] = useState(false);
const [orderDetails, setOrderDetails] = useState({
  orderId: null,
  currency: null,
  amount: null,
 });
useEffect(() => {
  if (orderDetails.orderId) {
    loadRazorpay(orderDetails);
  }
}, [orderDetails]);
const handleCreateOrder = async (amount, currency) => {
 
    try {

    const response=await axios.post(
    `${server}/api/Siemens/CreateOrder`,
    {
      amount: amount * 100, // amount in smallest currency unit
      currency: currency,
       EmpId: `${userId}`,
       MobileNo:`${userMobNo}`,
       VendorId:`${Vendor_Id()}`,
       CompanyId:`${Company_Id()}`,
       CorporateId:`${Corporate_Id()}`,
    },
    {
      headers: {
        Authorisation: `${JWTToken}`,
        "Content-Type": "application/json",
        // Add more headers if needed
      }
    }
  );

      const data = response.data;
 
      if (data && data.data.order_id) { 
        setOrderDetails({
          orderId: data.data.order_id,
          currency: data.data.currency,
          amount: data.data.amount,
        });
 

        // setDisplayRazorpay(true);

        
        loadRazorpay(data.data.order_id, data.data.amount, data.data.currency);
      }
    } catch (error) {
      console.error('Error creating Razorpay order:', error);
    }
  };
// useEffect(() => {
//   if (orderDetails.orderId) {
//     alert(orderDetails.orderId);  
//   }
// }, [orderDetails.orderId]);
let AirportLat = ''
  let AirportLon = ''
  let CircleRadius=5;
const loadRazorpay = (orderId, amount, currency) => {
  // alert(process.env.REACT_APP_RAZORPAY_KEY_ID)
  // debugger
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: amount,
      currency: currency,
      name: 'Refex EV',
      description: 'Test Transaction',
      order_id: orderId,
      handler: function (response) {
        // console.log(response);
        handlePaymentChanges('Success',response);
      },
      prefill: {
        name: 'Test User',
        email: 'test@example.com',
        contact: '9999999999',
      },
      notes: {
        address: 'Refex Green Mobility',
      },
      theme: {
        color: '#3399cc',
      },
      modal:{
        ondismiss: function () {
        // console.log('Payment popup closed by user');
        handlePaymentChanges('Modal closed by user','');
        // alert('Payment was cancelled');
      },
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.on('payment.failed', function (response) {
  
    // Razorpay explicitly reports payment failure 
    handlePaymentChanges('Payment Failed',response)
 
  });
    rzp.open();
  };
  

 const handlePaymentChanges = async (action,PaymentResponseJson) => {
  try {
    const response = await axios.post(
      `${server}/api/Siemens/HandlePayment`,
      {
        OrderId:orderDetails.orderId,
        EmpId: `${userId}`, 
        MobileNo: `${userMobNo}`,
        VendorId: `${Vendor_Id()}`,
        CompanyId: `${Company_Id()}`,
        CorporateId: `${Corporate_Id()}`,
        Status:action,
        jsonresponse:PaymentResponseJson
      },
      {
        headers: {
          Authorisation: `${JWTToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    if (action == 'Success') {
      // Handle successful payment
      BookAndPayCash();
    } else {
      // Handle failed payment
      // console.log('Payment failed:', PaymentResponseJson);
    }

    // console.log('Cancellation logged:', response.data);
  } catch (error) {
    console.error('Error logging cancellation:', error);
  }
};

 
  useEffect(() => {
    if (activeTab === "others") {
      setEmail("");
    } else {
      setEmail(localStorage.getItem("emailId") || "");
    }
  }, [activeTab]);

   useEffect(() => {
    if (activeTab === "others") {
      setContactNo("");
    } else {
      setContactNo(localStorage.getItem("contactNo") || "");
    }
  }, [activeTab]);

  setDefaults({
    key: "AIzaSyB8YbkwvUiwIUxKek_hMCPXBu9jEROJwL4", // Your API key here.
    language: "en", // Default language for responses.
    region: "es", // Default region for responses.
  });
  
  const [bookingOption, setBookingOption] = useState("Book Now");
  const [selectedCityId, setSelectedCityId] = useState("");
  const [SelectedServiceId, setSelectedServiceId] = useState('');
   const [SelectedTariff, setSelectedTariff] = useState("");
  const [Tariff, setTariff] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() + 3 * 60 * 60 * 1000));
  const [confirmedDate, setConfirmedDate] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const [searchResultFrom, setSearchResultFrom] = useState(null);
  const [searchResultTo, setSearchResultTo] = useState(null);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyB8YbkwvUiwIUxKek_hMCPXBu9jEROJwL4",
    libraries: placesLibrary,
  });


const localstorage1=localStorage.getItem("userid");
useEffect(() => {
  // console.log("localstorage1", localstorage1);
    if (localstorage1==null) {
      navigate('/');
    }
  }, [localstorage1]);

  const [selectedVehicleCatagory, setselectedVehicleCatagory] = useState([]);
// useEffect(() => {
//     if (SelectedServiceId) {
//         GetTariffs(SelectedServiceId);
//     }
// }, [SelectedServiceId]);
// useEffect(() => {
//     if (SelectedTariff) {
//         GetVehicleCatagories(SelectedTariff);
//     }
// }, [SelectedTariff]);
  useEffect(() => {
    if (selectedVehicleCatagory) {
        GetTariffs(selectedVehicleCatagory);
    }
}, [selectedVehicleCatagory]);

useEffect(() => {
    if (SelectedTariff) {
        GetEstimatedFare();
    }
}, [SelectedTariff]);

useEffect(() => {
    if (SelectedServiceId) {
        GetVehicleCatagories(SelectedServiceId);
    }
}, [SelectedServiceId]);
  
  const initialValues = {
    CompanyId: "",
    OrderId: "",
    BookerId: userId,
    CorporateId: "",
    Booker: userName,
    MakeId: "",
    Model: "",
    CorporateName: "",
    RatePlan: "",
    VendorId: "2583",
    VendorName: "RGML",
    OperatorID: "Website",
    CallerID: '',
    CallerName: userName,
    TaxiCategoryId: "", //"2",
    TaxiCategory: "", //"Sedan",
    RatePlanId: "",
    TariffId: "", // "1464266",
    Tariff: "", //"AIRPORT TO CITY",
    RequestPickUpTime: "", // "2023-09-10 12:20:00",
    NoOfDays: "1",
    PickupAddress: "", // "KR Puram",
    PickupMessage: "",
    Pickuplat: "",
    Pickuplon: "",
    DropOffAddress: "", // "Mekhri circle",
    DropOfflat: "", //"77.98",
    DropOfflon: "", // "13.999",
    TypeOfTripId: "", //"1464266",
    Noofpassengers: "3",
    NoOFVehicles: "1",
    GuestEmailId: "",
    GuestMobileNum: "",
    paymenttypeid: "2",
    paymenttype: "Cash",
    email: userEmailId,
    BookingFare: 0,
    CityId: 0,
    ServiceTypeId: "",
    tariffId: "",
    vehicleCatIdId: "",
    BookingType: "",
    CalculatedBaseFare: 0,
    CalculatedBaseDistance: 0,
    PickupCity: "",
    PickupCityId: "",
    ModelId: "",
    GuestName: "",
    GuestEmailId: "",
    GuestMobileNum: "",
    JWTToken: localStorage.getItem("Token"),
  };
const [name, setName] = useState(
  localStorage.getItem("EmployeeName") || ""
);

  const [formvalue, setFormValue] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [IsSubmit, setIsSubmit] = useState(false);

  const [corportate, setCorporate] = useState([
    { ValueId: "13647", valueText: "O3MPLRetail" },
  ]);

  const [vechaleCat, setvechaleCat] = useState([]);
  const [ServiceType, setServiceType] = useState([]);
  const [Cities, setCities] = useState([]);
    const [VehicleCatagories, setVehicleCatagories] = useState([]);
     
  async function Get_VehicleCategory() {
    try {
      const response = await fetch(
        `${server}/api/O3Mobility/VehicleCategoryGet/${Company_Id()}/${Corporate_Id()}/${Vendor_Id()}`,
        {
          method: "GET",
          headers: {
            Authorization: `${JWTToken}`,
            "Content-Type": "application/json", // Add more headers as needed
          },
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const body = await response.json();
      if (response.status == 401) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Session Expired Please Login Again",
        });
        navigate("/Login");
      }

      setvechaleCat(body.vehicleCat_lst);
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "SomeThing Went wrong Please Try Again",
      });
    }
  }
  //tariff details...................
  const [tripType, setTripType] = useState([]);
 
  const handChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formvalue, [name]: value });
    // get_EstimateFare();
    if (name == "RequestPickUpTime") {
      const selectedDate = new Date(e.target.value);
      const currentDate = new Date();
      const timeDifference =
        (selectedDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60);
      if (timeDifference < 4) {
        formErrors.RequestPickUpTime =
          "Selected date should be at least 4 hours ahead of the current date and time.";
        setFormValue({ ...formvalue, [name]: "" });
      } else {
        const formattedDate = selectedDate.toISOString().slice(0, 16);
        formvalue.RequestPickUpTime = formattedDate;
        formErrors.RequestPickUpTime = "";
        setFormValue({ ...formvalue, [name]: value });
      }
    }
    // console.log('form-val-', formvalue);
  };
  const handleSubmit = async (e) => {
    console.log("formvalue", formvalue);
    e.preventDefault();
    setFormErrors(validate(formvalue));
    setIsSubmit(true);
  };
  async function SubmitDetails(formvalue) {
    // navigate("/Bookingconfirm", { state: { formvalue } });
  }



  async function GetVehicleCatagories() {
    try {
      const response = await fetch(`${server}/api/Siemens/LoadVehicleModels`, {
        method: "POST",
        headers: {
          Authorisation: `${JWTToken}`, // Fix spelling: 'Authorization'
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            CompanyId: `${Company_Id()}`,
            GeoLocationId: `${selectedCityId}`,
            EmpId: `${userId}`,
            CorporateId: `${Corporate_Id()}`,
            Triptypeid: `${SelectedServiceId}`,
            VendorId: `${Vendor_Id()}`
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const body = await response.json();
      if (response.status == 401) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Session Expired Please Login Again",
        });
        navigate("/Login");
      }
      // console.log("Cities response:", body.data);
      setVehicleCatagories(body.data);
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:  "SomeThing Went wrong Please Try Again",
      });
    }
  }

 
  async function GetTariffForAirportTrips() {
     try {
      const response = await fetch(`${server}/api/Siemens/GetTariffForAirportTrips`, {
        method: "POST",
        headers: {
          Authorisation: `${JWTToken}`, // Fix spelling: 'Authorization'
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
         CompanyId: `${Company_Id()}`,
            GeoLocationId: `${selectedCityId}`,
            EmpId: `${userId}`,
            RoleId: "3",
            LoginId: "0",
            tariffId: `${SelectedTariff}`,
            TripTypeId: `${SelectedServiceId}`,
            GDistance: `${formvalue.CalculatedBaseDistance ?? "0"}`,

            VendorId: `${Vendor_Id()}`,
            Time: formvalue.GTime,
            GTime: formvalue.GTime,
            EmployeeTypeId: "1",
            CorporateId: `${Corporate_Id()}`,
            FromLat: formvalue.Pickuplat,
            FromLon: formvalue.Pickuplon,
            ToLat: formvalue.DropOfflat,
            ToLon: formvalue.DropOfflon,
            userMobNo: userMobNo,
            VehicleId: document.getElementById("VehicleId").value,
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const body = await response.json();
      // console.log("Estimated Fare response:", body);
      // formvalue.CalculatedBaseFare = body.data[0].EstimatedFare;
      
    //   debugger;
      // document.getElementById("calculated_Fare").innerHTML ='Estimated Fare  RS '+  body.data[0].EstimatedFare;
      // debugger;
      // SelectedTariff = body.data[0].ID;
      setSelectedTariff(body.data[0].ID);
      if (response.status == 401) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Session Expired Please Login Again",
        });
        navigate("/Login");
      }
      // console.log("Cities response:", body.data);
    //   setCities(body.data);
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      // Swal.fire({
      //   icon: "error",
      //   title: "Oops...",
      //   text: "Please Enter serviceable Area",
      // });
      document.getElementById("calculated_Fare").innerHTML ='Estimated Fare  RS null';
      formvalue.BookingFare = null;

    }
  }



  async function GetEstimatedFare() {

    if((SelectedTariff == '-1' || SelectedTariff == null ||
       SelectedTariff == undefined) && SelectedServiceId=='3' && formvalue.CalculatedBaseDistance != null && formvalue.CalculatedBaseDistance != undefined && formvalue.CalculatedBaseDistance != '') {
      GetTariffForAirportTrips();
    }
    // debugger;





    try {
      const response = await fetch(`${server}/api/Siemens/EstimatedFare`, {
        method: "POST",
        headers: {
          Authorisation: `${JWTToken}`, // Fix spelling: 'Authorization'
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
         CompanyId: `${Company_Id()}`,
            GeoLocationId: `${selectedCityId}`,
            EmpId: `${userId}`,
            RoleId: "3",
            LoginId: "0",
            tariffId: `${SelectedTariff}`,
            TripTypeId: `${SelectedServiceId}`,
            GDistance: `${formvalue.CalculatedBaseDistance ?? "0"}`,

            VendorId: `${Vendor_Id()}`,
            Time: formvalue.GTime,
            GTime: formvalue.GTime,
            EmployeeTypeId: "1",
            CorporateId: `${Corporate_Id()}`,
            FromLat: formvalue.Pickuplat,
            FromLon: formvalue.Pickuplon,
            ToLat: formvalue.DropOfflat,
            ToLon: formvalue.DropOfflon,
            userMobNo: userMobNo,
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const body = await response.json();
      // console.log("Estimated Fare response:", body);
      formvalue.CalculatedBaseFare = body.data[0].EstimatedFare;
      
    //   debugger;
      document.getElementById("calculated_Fare").innerHTML ='Estimated Fare  RS '+  body.data[0].EstimatedFare;
      formvalue.BookingFare = body.data[0].EstimatedFare;

      if (response.status == 401) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Session Expired Please Login Again",
        });
        navigate("/Login");
      }
      // console.log("Cities response:", body.data);
    //   setCities(body.data);
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Enter serviceable Area",
      });
      document.getElementById("calculated_Fare").innerHTML ='Estimated Fare  RS null';
      formvalue.BookingFare = null;

    }
  }

  
  async function GetCities() {
    try {
      const response = await fetch(`${server}/api/Siemens/GetCityList`, {
        method: "POST",
        headers: {
          Authorisation: `${JWTToken}`, // Fix spelling: 'Authorization'
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          MobileNo: userMobNo,
          UserName: userName,
          CompanyId: `${Company_Id()}`,
          UserId: userId,
          EmailId: userEmailId, // Seems incorrect: Should this be email instead of mobile number?
          CorporateId: `${Corporate_Id()}`,
          CorporateName: Corporate_Name(),
          VendorId: `${Vendor_Id()}`,
          VendorName: Vendor_Name(),
          EmpId: userId,
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const body = await response.json();
      if (response.status == 401) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Session Expired Please Login Again",
        });
        navigate("/Login");
      }
      // console.log("Cities response:", body.data);
      setCities(body.data);

      setSelectedServiceId('-1');
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "SomeThing Went wrong Please Try Again",
      });
    }
  }
 async function GetTariffs() {
    try {
      const response = await fetch(`${server}/api/Siemens/LoadTariff`, {
        method: "POST",
        headers: {
          Authorisation: `${JWTToken}`, // Fix spelling: 'Authorization'
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            CompanyId: `${Company_Id()}`,
            GeoLocationId: `${selectedCityId}`,
            EmpId: `${userId}`,
            CorporateId: `${Corporate_Id()}`,
            TripType: `${SelectedServiceId}`,
            VendorId: `${Vendor_Id()}`,
            Vehiclemodelid: `${selectedVehicleCatagory}`,
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const body = await response.json();
      if (response.status == 401) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Session Expired Please Login Again",
        });
        navigate("/Login");
      }
      // console.log("Cities response:", body.data);
      setTariff(body.data);
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "SomeThing Went wrong Please Try Again",
      });
    }
  }
  async function GetServiceTypes() {
    try {
      const response = await fetch(`${server}/api/Siemens/GetServiceTypes`, {
        method: "POST",
        headers: {
          Authorisation: `${JWTToken}`, // Fix spelling: 'Authorization'
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CompanyId: `${Company_Id()}`,
          UserId: `${userId}`,
          CorporateId: `${Corporate_Id()}`,
          VendorId: `${Vendor_Id()}`,
          EmpId: `${userId}`,
          GeoLocationId: `${selectedCityId}`,
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const body = await response.json();
      if (response.status == 401) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Session Expired Please Login Again",
        });
        navigate("/Login");
      }

      setServiceType(body.data);
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "SomeThing Went wrong Please Try Again",
      });
    }
  }

  useEffect(() => {
    // console.log(JWTToken);
    // Get_VehicleCategory();
    // GetCities();
    // GetServiceTypes();
    // Get_Traiff();
    if (Object.keys(formErrors).length == 0 && IsSubmit) {
      // console.log(formvalue);
      //  debugger;
      SubmitDetails(formvalue);
    }
  }, [formErrors]);


  useEffect(() => {
    // console.log(JWTToken);
    // Get_VehicleCategory();
    GetCities();
    GetServiceTypes();
    // Get_Traiff();
     
  }, []);

  const validate = (value) => {
    // alert(SelectedServiceId)
    // debugger;
    const errors = {};
    // if(activeTab == "others")
    // {
    //   // userMobNo
    //   // userName
    // }
  if(activeTab == "others") {
    formvalue.GuestEmailId = document.getElementById("emailId").value;
    formvalue.GuestMobileNum = document.getElementById("contactNo").value;
    formvalue.GuestName = document.getElementById("CallerName").value;

    if (!formvalue.GuestName || formvalue.GuestName == '') {
      errors.CallerName = "Full name is required";
    }
    if (!formvalue.GuestEmailId || formvalue.GuestEmailId == '') {
      errors.emailId = "Email is required";
    }
    if( !formvalue.GuestMobileNum || formvalue.GuestMobileNum == '') {
       errors.CallerID = "Mobile No is required";
    }
  }
    
    
    formvalue.CallerName = localStorage.getItem("EmployeeName");
    formvalue.CorporateId = localStorage.getItem("Corporate_Id()");
    formvalue.CorporateId = localStorage.getItem("Corporate_Id()");
    formvalue.CorporateName=localStorage.getItem("Corporate_Name()")
    
    formvalue.CompanyId = localStorage.getItem("Company_Id()");
    formvalue.email = userEmailId;
    formvalue.CityId = document.getElementById("CityId").value;

    formvalue.ServiceId = document.getElementById("ServiceId").value;

    formvalue.TariffId = document.getElementById("TariffId").value;

    formvalue.VehicleId = document.getElementById("VehicleId").value;
    formvalue.ModelId = selectedVehicleCatagory;
 
    formvalue.PickupAddress = document.getElementById("PickupAddress").value;
    formvalue.DropOffAddress = document.getElementById("dropAddress").value;

     
    // formvalue.Tariff= document.getElementById("TariffId").innerHTML;
    formvalue.MakeId = document.getElementById("VehicleId").value;
    // formvalue.Model = document.getElementById("VehicleId").innerHTML;
    // formvalue.GDistance = document.getElementById("GDistance").value;
    formvalue.RatePlanId= document.getElementById("ServiceId").value;
    
  const selectedServiceId = document.getElementById("ServiceId");
const selectedServiceIdText = selectedServiceId.options[selectedServiceId.selectedIndex].text;
formvalue.RatePlan= selectedServiceIdText;



  const selectedVehicleId = document.getElementById("VehicleId");
  
const selectedVehicleIdText = selectedVehicleId.options[selectedVehicleId.selectedIndex].text;
formvalue.Model= selectedVehicleIdText;


const selectedTariffId = document.getElementById("TariffId");
const selectedTariffText = selectedTariffId.options[selectedTariffId.selectedIndex].text;
formvalue.Tariff= selectedTariffText;

    // formvalue.CalculatedBaseFare =
    //   document.getElementById("calculated_Fare").innerHTML;
formvalue.CallerID = userMobNo;
    if (!value.CallerName) {
      errors.CallerName = "Full name is required";
    }

    if (!value.PickupAddress) {
      errors.PickupAddress = "From location is required";
    }

    if (!value.DropOffAddress) {
      errors.DropOffAddress = "To location is required";
    }

    if (!value.BookingFare) {
      errors.BookingFare = "Please Enter a Valid Location";
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Enter a Valid Location",
      });
      return errors;
    }
    if (!value.email) {
        errors.emailId = "Email id is required";
    }
      if (!value.CallerID) {
        errors.CallerID = "Mobile No is required";
    } 
    if(!selectedCityId|| selectedCityId=='-1'){
            errors.selectedCityId = "Select City"; 
    }if(!SelectedServiceId|| SelectedServiceId=='-1'){
            errors.SelectedServiceId = "Select ServiceType"; 
    }
    // debugger;
    if((!SelectedTariff || SelectedTariff=='-1') && IsHideAirport == 'True' &&( SelectedServiceId != '3' || SelectedServiceId != '-1')){
            errors.SelectedTariff = "Select Tariff";
    }

    if(!value.VehicleId||value.VehicleId == "-1"){
            errors.selectedVehicleCatagory = "Select Vehicle Category";
    }
//  debugger
    if (bookingOption == "Book Later") {
       console.log(confirmedDate)
      if (!confirmedDate) {
        errors.RequestPickUpTime = "Pickup time is required";
        alert("Please select a pickup time");
        console.log(errors);
        return errors;
      }
       
      formvalue.RequestPickUpTime = formatToIST(confirmedDate);
      if (Object.keys(errors).length === 0) {
        BookAndPayCash();
      }
      // console.log('errors', errors); 
      // BookAndPayCash();
      // alert(Object.keys(errors).length);
      //  if (Object.keys(errors).length === 0) {
      //   // BookAndPayCash();
      //   handleCreateOrder(formvalue.BookingFare, "INR");
      // }

      
//       if (Object.keys(errors).length === 0) {
//   Swal.fire({
//     title: 'Choose Payment Option',
//     text: 'Would you like to pay now or later?',
//     icon: 'question',
//     showCancelButton: true,
//     confirmButtonText: 'Pay Now',
//     cancelButtonText: 'Pay Later',
//     reverseButtons: true
//   }).then((result) => {
//     if (result.isConfirmed) {
//       // User clicked "Pay Now"
//       handleCreateOrder(formvalue.BookingFare, "INR");
//     } else if (result.dismiss === Swal.DismissReason.cancel) {
//       // User clicked "Pay Later"
//       BookAndPayCash(); // Call your function to just book the ride
//     }
//   });
// }

      // {confirmedDate && bookingOption 
      // if (!confirmedDate) {
      //   errors.RequestPickUpTime = "Pickup time is required";
      //   alert("Please select a pickup time");
      //   return errors;
      // } else {
      //   formvalue.BookingType = "bookLater";
      // }
     
    }

    if (bookingOption == "Book Now") {
      // debugger;
      // formvalue.RequestPickUpTime = formatToIST(new Date(new Date().getTime() + 3 * 60 * 60 * 1000));

      // formatToIST(confirmedDate);
      // console.log('formvalue-', formvalue);
      // alert(Object.keys(errors).length);
if (Object.keys(errors).length === 0) {
  Swal.fire({
    title: 'Confirm Booking?',
    text: 'For Book Now, pickup time will be scheduled 3 hours from now.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, Book Now',
    cancelButtonText: 'Cancel'
  })
  .then((result) => {
    if (result.isConfirmed) {
      // Set pickup time to 3 hours from now
      formvalue.RequestPickUpTime = formatToIST(new Date(new Date().getTime() + 3 * 60 * 60 * 1000));
      BookAndPayCash();
      // Show second alert for payment option
      // Swal.fire({
      //   title: 'Choose Payment Option',
      //   text: 'Would you like to pay now or later?',
      //   icon: 'question',
      //   showCancelButton: true,
      //   confirmButtonText: 'Pay Now',
      //   cancelButtonText: 'Pay Later',
      //   reverseButtons: true
      // }).then((payResult) => {
      //   if (payResult.isConfirmed) {
      //     handleCreateOrder(formvalue.BookingFare, "INR"); // Pay Now
      //   } else if (payResult.dismiss === Swal.DismissReason.cancel) {
      //     BookAndPayCash(); // Pay Later (just book the ride)
      //   }
      // });
    }
  });
}

    }

    return errors;
  };


  useEffect(() => {
  if (activeTab === "others") {
    setName("");
  } else {
    setName(localStorage.getItem("EmployeeName") || "");
  }
}, [activeTab]);
function formatToIST(date) {
  const istDate = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));

  const pad = (n, z = 2) => String(n).padStart(z, '0');

  return (
    istDate.getFullYear() + '-' +
    pad(istDate.getMonth() + 1) + '-' +
    pad(istDate.getDate()) + ' ' +
    pad(istDate.getHours()) + ':' +
    pad(istDate.getMinutes()) + ':' +
    pad(istDate.getSeconds()) + '.' +
    pad(istDate.getMilliseconds(), 3)
  );
}
async function BookAndPayCash() { 
// debugger
    if(activeTab == "others") {
      formvalue.GuestEmailId = document.getElementById("emailId").value;
      formvalue.GuestMobileNum = document.getElementById("contactNo").value;
      formvalue.GuestName = document.getElementById("CallerName").value;
    }
  
        formvalue.EmpId = userId;
        // formvalue.Pickupcity=document.getElementById("CityId").value;
        formvalue.PickupCityId = selectedCityId;
        const selectedPickupCity = document.getElementById("CityId");
const selectedselectedPickupCityText = selectedPickupCity.options[selectedPickupCity.selectedIndex].text;
formvalue.PickupCity= selectedselectedPickupCityText;
        // formvalue.BookerId = userId;
        // formvalue.BookerName = userName;
        // console.log('formvalue-', formvalue);
        debugger;
  if (SelectedServiceId == '3') {
    const distances = CheckForSevicableArea();

    if (
      distances.distanceFromAirportToPickup >= CircleRadius &&
      distances.distanceFromDropOffToAirport >= CircleRadius
    ) {
      alert('Please select a pickup or drop location as airport.');
      return;
    }
  }

        let result = await fetch(`${server}/api/Siemens/bookairportvechicle`,
            {
                method: "POST",
                headers: {
          Authorisation: `${JWTToken}`, // Fix spelling: 'Authorization'
          "Content-Type": "application/json",
        },
                body: JSON.stringify(formvalue),
            }
        );
        // console.log('res-', result);
        result = await result.json();

        if (result.statusCode === 401){
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Unauthorized Access !!',
            })
            navigate('/login');
            return;
        } 
        // console.log('cash response', result);
        // alert(result.statusCode);
        if (result.statusCode == 200) {
            // navigate('/success');
            setShowToast(true);
        }
    }

 
  //get user current location ===================================================
  const getUserCurrentLocation = () => {
    navigator.permissions
      .query({ name: "geolocation" })
      .then(function (result) {
        if (result.state == "granted") {
          getLocation();
        } else if (result.state == "prompt") {
          report(result.state);
        } else if (result.state == "denied") {
          report(result.state);
        }
        result.onchange = function () {
          report(result.state);
        };
      });
  };
  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      // console.log("not conneted");
    }
  }
  function showPosition(position) {
    var latval = position.coords.latitude;
    var lonval = position.coords.longitude;

    // console.log('lat value-', latval.toString());
    // console.log('lon value-', lonval.toString());

    formvalue.Pickuplat = latval.toString();
    formvalue.Pickuplon = lonval.toString();

    get_EstimateFare();
    //  console.log(formvalue);

    fromLatLng(position.coords.latitude, position.coords.longitude).then(
      ({ results }) => {
        var address = results[0].formatted_address;
        const PickupAddresselement = document.getElementById("PickupAddress");
        if (PickupAddresselement) {
          PickupAddresselement.value = address;
        } else {
          console.warn("Element with id 'PickupAddress' not found.");
        }
      }
    );
    // .catch(console.error);
  }
  function report(state) {
    // console.log('Permission ' + state);
    //alert(state);
  }
  function onLoadTo(autocomplete) {
    setSearchResultTo(autocomplete);
  }
   async function onPlaceChangedFrom() {
     
    if (searchResultFrom != null) {
      const place = searchResultFrom.getPlace();
      var latval = place.geometry.location.lat();
      var lonval = place.geometry.location.lng();
      // console.log('Pickup lat value-', latval.toString());
      // console.log(' Pickup lon value-', lonval.toString());
      formvalue.Pickuplat = latval.toString();
      formvalue.Pickuplon = lonval.toString();
       await get_EstimateFare();//GDistance
      GetEstimatedFare();
     if(SelectedServiceId=='3') {
      GetTariffForAirportTrips();
      }
    } else {
      alert("Please enter text for From Location");
    }
  }
  function onLoadFrom(autocomplete) {
    getUserCurrentLocation();
    setSearchResultFrom(autocomplete);
  }
  async function onPlaceChangedTo() {
    
    if (searchResultTo != null) {
      const place = searchResultTo.getPlace();
      var latval = place.geometry.location.lat();
      var lonval = place.geometry.location.lng();
      // console.log('drop lat value-', latval.toString());
      // console.log(' drop lon value-', lonval.toString());
      formvalue.DropOfflat = latval.toString();
      formvalue.DropOfflon = lonval.toString();
      await get_EstimateFare();

      if(SelectedServiceId=='3') {
      GetTariffForAirportTrips();
      }
      
      
    } else {
      alert("Please enter text for To Location");
    }
  }
  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  //end section.=================



async function GetTheAirportLocation(value) { 
  // console.log('value-', value);
    try {
      const response = await fetch(`${server}/api/Siemens/GetAirportLatLonBasedOnCity`, {
        method: "POST",
        headers: {
          Authorisation: `${JWTToken}`, // Fix spelling: 'Authorization'
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CompanyId: `${Company_Id()}`,
          UserId: `${userId}`,
          CorporateId: `${Corporate_Id()}`,
          VendorId: `${Vendor_Id()}`,
          EmpId: `${userId}`,
          GeolocationId: `${value}`,
        
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const body = await response.json();
      if (response.status == 401) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Session Expired Please Login Again",
        });
        navigate("/Login");
      }

      // console.log("Airport Location response:", body);
      // AirportLat = body.data[0].Latitude;
      // AirportLon = body.data[0].Longitude;
      setAirportLatitude(body.data[0].Latitude);
      setAirportLongitude(body.data[0].Longitude);


    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "SomeThing Went wrong Please Try Again",
      });
    }


}






  async function BookNow1(formvalue) {
    try {
      //console.log('formvalue-' + formvalue);
      //let result = await fetch('http://192.168.1.121:83/api/Booking/bookairportvechicle', {
      let result = await fetch(
        "https://localhost:7291/api/Booking/bookairportvechicle",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "text/plain",
          },
          body: JSON.stringify(formvalue),
        }
      );
      result = await result.json();
      // console.log('result--', result);
      if (
        result.statusCode === 200 &&
        result.statusMessage === "Booking Successfully Done." &&
        result.bookingId != ""
      ) {
        Swal.fire(
          "Successfully Done!",
          "You Booking Successfully Done!",
          "success"
        );
        //navigate('/Dashboard');
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "test-" + result.statusMessage,
        });
      }
    } catch (errors) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errors.title,
      });
    }
  }
  //console.log('profile data',getPreData);
  const inputstyles = {
    backgroundColor: "#fff",
    padding: "0 2em",
    border: "none",
    padding: "0px",
  };

  const haversineDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the Earth in km
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in km
    return distance;
  };
  
function ChaekForIsAirportServiceType(type) {
    // console.log('formvalue-', formvalue);
    // alert(type);
    // alert(IsHideAirport)
    // debugger;
        if(type == '3' && IsHideAirport == 'True') {
    document.getElementById('TariffIdRow').style.display = 'none';

        }
        else {
           document.getElementById('TariffIdRow').style.display = 'block';
        }
}

  function CheckForSevicableArea() {
    // debugger;
    var airportlat = AirportLatitude;
    var airportlon = AirportLongitude;
 
    const DISTANCEBWatoc = haversineDistance(
      airportlat,
      airportlon,
      formvalue.Pickuplat,
      formvalue.Pickuplon
    );
    const DISTANCEBWatob = haversineDistance(
      formvalue.DropOfflat,
      formvalue.DropOfflon,
      formvalue.Pickuplat,
      formvalue.Pickuplon
    );
    const DISTANCEBWctoa = haversineDistance(
      airportlat,
      airportlon,
      formvalue.DropOfflat,
      formvalue.DropOfflon
    );

    return {
      distanceFromAirportToPickup: DISTANCEBWatoc,
      distanceFromDropOffToAirport: DISTANCEBWctoa,
      distanceBetweenPickupAndDropOff: DISTANCEBWatob,
    };
  }

  async function BookNow3() {
    var CallerName = document.getElementById("CallerName").value;
    var email = document.getElementById("emailId").value;
    var tripType = document.getElementById("selectedTripId").value;
    var vm = document.getElementById("vehiclemodal");
    var TaxiCategory = vm.options[vm.selectedIndex].text;
    var e = document.getElementById("TariffId");
    var Tariff = e.options[e.selectedIndex].text;
    var PickupAddress = document.getElementById("PickupAddress").value;
    var DropOffAddress = document.getElementById("dropAddress").value;
    var amount = document.getElementById("fareValueId").innerHTML;
    localStorage.setItem("name", CallerName);
    localStorage.setItem("email", email);
    localStorage.setItem("contactno", CallerName);
    localStorage.setItem("fromlocation", PickupAddress);
    localStorage.setItem("tolocation", DropOffAddress);
    localStorage.setItem("triptype", Tariff);
    localStorage.setItem("vehiclecategory", TaxiCategory);
    localStorage.setItem("bookingdate", formvalue.RequestPickUpTime);
    localStorage.setItem("amount", amount);

    // navigate("/Bookingconfirm");
  }


  async function get_EstimateFare() {

    var Pickuplat = formvalue.Pickuplat;
    var pickuplon = formvalue.Pickuplon;

    var DropOfflat = formvalue.DropOfflat;
    var DropOfflon = formvalue.DropOfflon;

    //const response = await fetch(`${server}/api/Dashboard/getlocationwithdistance/` + Pickuplat + `/` + pickuplon + `/` + DropOfflat + `/` + DropOfflon);
    const response = await fetch(`${server}/api/Siemens/GetGoogleDistandTime`, {
    method: "POST",
    headers: {
        "Authorisation": `${JWTToken}`, // Ensure correct token format
        "Content-Type": "application/json"
    },
    body: JSON.stringify({
        startlat: Pickuplat,
        startlon: pickuplon,
        endlat: DropOfflat,
        endlon: DropOfflon,
        EmpId: userId // No need for `${userId}` here
    }),
});

 // Runs whenever selectedServiceId changes


    const body = await response.json();

    var dist_duration = body.distance;
    var GOOGLE_DURATION = body.duration;
 
// debugger;
    var distanceKm = parseFloat(dist_duration) / 1000;
    var durationMinut = parseFloat(GOOGLE_DURATION) / 60;
    // formvalue.CalculatedBaseDistance = body.data[0].GDistance;
  formvalue.CalculatedBaseDistance = distanceKm;
  // alert(formvalue.CalculatedBaseDistance);
    document.getElementById("calculated_distance").innerHTML ='Estimated Distance '+
      distanceKm+' km';
      GetEstimatedFare();

    // const apiUrl = 'https://captain-api.eveelz.in/driverapp/getestimatedfare';
    
  }

  return (
    
    <>
      <div>
        <MasterPage heading="Add Booking" />
      </div>
      
      {/* <div className="content-wrapper" style={{ minHeight: '881px' }}> */}

      <div
        className="d-flex justify-content-center mt-4"
        style={{ minHeight: "900px" ,fontFamily: "Poppins",width: "100%"}}
      >
        <div className="col-lg-5 col-md-8 col-sm-12">
          <div className="card">
            <div
              className="booking-tabContainer"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div
                className={`tabs ${
                  activeTab === "myself" ? "activeTab" : "inactiveTab"
                }`}
                onClick={() => setActiveTab("myself")}
                style={{
                  cursor: "pointer",
                  padding: "15px 120px",
                  paddingTop: "15px",
                  margin: "0 5px",
                  backgroundColor: activeTab === "myself" ? "#70B92F" : "white",
                  color: activeTab === "myself" ? "white" : "black",
                  borderRadius: "4px",
                  // fontWeight: 'bold'
                }}
              >
                Myself
              </div>

              <div
                className={`tabs ${
                  activeTab === "others" ? "activeTab" : "inactiveTab"
                }`}
                onClick={() => setActiveTab("others")}
                style={{
                  cursor: "pointer",
                  padding: "15px 120px",
                  margin: "0 4px",
                  backgroundColor: activeTab === "others" ? "#70B92F" : "white",
                  color: activeTab === "others" ? "white" : "black",
                  borderRadius: "4px",
                  whiteSpace: "nowrap",
                  // fontWeight: 'bold'
                }}
              >
                For Others
              </div>
            </div>
          </div>

          {/* <hr /> */}

          <div className="card-body">
            <form>
              <div className="row mb-3">
                {" "}
                {/* Added mb-3 here */}
                <div className="col-md-6">
                  {/* {alert(activeTab)} */}
                  <label style={{ fontWeight: "400" }} className="text-muted">Name</label>
                  <input
  id="CallerName"
  type="text"
  className="form-control text-muted"
  placeholder="Enter Name"
  value={name}
  onChange={(e) => setName(e.target.value)}
  readOnly={activeTab !== "others"}
/>
{<p style={{"height":"0px"}} className="text-danger">{formErrors.CallerName}</p>}
                </div>
                <div className="col-md-6">
                  <label style={{ fontWeight: "400" }} className="text-muted">Email ID</label>
                  <input id="emailId"
                    type="email"
                    value={email}
        onChange={(e) => setEmail(e.target.value)}
                    className="form-control text-muted"
                    placeholder="Enter Email ID"
                     
                    readOnly={activeTab !== "others"}
                  />{<p style={{"height":"0px"}} className="text-danger">{formErrors.emailId}</p>}
                </div>
              </div>

              <div className="row mb-3">
                {" "}
                {/* Added mb-3 here */}
                <div className="col-md-6">
                  <label style={{ fontWeight: "400" }} className="text-muted">Contact No</label>
                  <input id="contactNo"
                    type="text"
                     maxLength="10"
                     
                    inputMode="numeric" // Suggests numeric keyboard on mobile devices
                    pattern="\d*" 
                    className="form-control text-muted"
                    placeholder="Enter Contact No"
                    value={contactNo}
        // onChange={(e) => setContactNo(e.target.value)}
         onChange={(e) => {
    const onlyNumbers = e.target.value.replace(/\D/g, ''); // remove non-digits
    setContactNo(onlyNumbers);
  }}
                    readOnly={activeTab !== "others"}
                  />{<p style={{"height":"0px"}} className="text-danger">{formErrors.CallerID}</p>}
                </div>
                <div className="col-md-6">
                  <label style={{ fontWeight: "400" }} className="text-muted">City</label>
                  <select id="CityId" className="form-control text-muted"   
                  onChange={(e) => { 
        setSelectedCityId(e.target.value); 
        setSelectedServiceId('-1');
        setselectedVehicleCatagory('-1');
        GetTheAirportLocation(e.target.value); // Call additional function
        
        setSelectedTariff('-1')
        GetEstimatedFare(); // Call additional function
    }}
            value={selectedCityId}><option value="-1">Select City</option>
                    {Cities ? (
                      Cities.map((city, index) => (
                        <option key={index} value={city.Id}>
                          {city.Name}
                        </option>
                      ))
                    ) : (
                      <option>No Cities </option>
                    )}
                  </select>{<p style={{"height":"0px"}} className="text-danger">{formErrors.selectedCityId}</p>}
                </div>
              </div>

              {/* Rest of your form unchanged */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label style={{ fontWeight: "400" }} className="text-muted">Service Type</label>
                  <select id="ServiceId" className="form-control text-muted"  onChange={(e) => { 
        setSelectedServiceId(e.target.value); 
        setselectedVehicleCatagory('-1');
        setSelectedTariff('-1');

        ChaekForIsAirportServiceType(e.target.value);

        GetEstimatedFare();
        //GetTariffs(e.target.value); // Call additional function
    }} 
 // Capture selected city
            value={SelectedServiceId}><option value="-1">Select Service Type</option>
                    {ServiceType ? (
                      ServiceType.map((city, index) => (
                        <option key={index} value={city.Id}>
                          {city.TripType}
                        </option>
                      ))
                    ) : (
                      <option>No ServiceTypes </option>
                    )}
                  </select>{<p style={{"height":"0px"}} className="text-danger">{formErrors.SelectedServiceId}</p>}
                </div>
                {/* <div className="col-md-6">
                  <label style={{ fontWeight: "400" }} className="text-muted">Tariff</label>
                  <select id="TariffId" className="form-control text-muted"  onChange={(e) => { 
        setSelectedTariff(e.target.value); 
    }} 
            value={SelectedTariff}><option value="-1">Select Tariff</option>
                    {Tariff ? (
                      Tariff.map((city, index) => (
                        <option key={index} value={city.ID}>
                          {city.TariffName}
                        </option>
                      ))
                    ) : (
                      <option>No Tariff Found </option>
                    )}
                  </select>{<p style={{"height":"0px"}} className="text-danger">{formErrors.SelectedTariff}</p>}
                </div>
              </div>
              <div  className="form-group"> 
                <label style={{ fontWeight: "400" }} className="text-muted text-muted">Vehicle Category</label>
                <select id="VehicleId" className="form-control" onChange={(e) => { 
        setselectedVehicleCatagory(e.target.value); 
        GetEstimatedFare(); // Call additional function
    }}  value={selectedVehicleCatagory}><option value="-1">Select Vehicle Category</option>
                  {VehicleCatagories ? (
                      VehicleCatagories.map((city, index) => (
                        <option key={index} value={city.Id}>
                          {city.CategoryName}
                        </option>
                      ))
                    ) : (
                      <option>No Vehicle Found </option>
                    )}
                </select>{<p style={{"height":"0px"}} className="text-danger">{formErrors.selectedVehicleCatagory}</p>}
              </div> */}
 <div  className="col-md-6"> 
                <label style={{ fontWeight: "400" }} className="text-muted text-muted">Vehicle Category</label>
                <select id="VehicleId" className="form-control" onChange={(e) => { 
        setselectedVehicleCatagory(e.target.value); 
        setSelectedTariff('-1');
        GetEstimatedFare(); // Call additional function
    }}  value={selectedVehicleCatagory}><option value="-1">Select Vehicle Category</option>
                  {VehicleCatagories ? (
                      VehicleCatagories.map((city, index) => (
                        <option key={index} value={city.Id}>
                          {city.CategoryName}
                        </option>
                      ))
                    ) : (
                      <option>No Vehicle Found </option>
                    )}
                </select>{<p style={{"height":"0px"}} className="text-danger">{formErrors.selectedVehicleCatagory}</p>}
              </div>


  
              </div>
              {/* <div  className="form-group"> 
                <label style={{ fontWeight: "400" }} className="text-muted text-muted">Vehicle Category</label>
                <select id="VehicleId" className="form-control" onChange={(e) => { 
        setselectedVehicleCatagory(e.target.value); 
        GetEstimatedFare(); // Call additional function
    }}  value={selectedVehicleCatagory}><option value="-1">Select Vehicle Category</option>
                  {VehicleCatagories ? (
                      VehicleCatagories.map((city, index) => (
                        <option key={index} value={city.Id}>
                          {city.CategoryName}
                        </option>
                      ))
                    ) : (
                      <option>No Vehicle Found </option>
                    )}
                </select>{<p style={{"height":"0px"}} className="text-danger">{formErrors.selectedVehicleCatagory}</p>}
              </div>  */}
<div className="col-md-6" id="TariffIdRow">
                  <label style={{ fontWeight: "400" }} className="text-muted">Tariff</label>
                  <select id="TariffId" className="form-control text-muted"  onChange={(e) => { 
        setSelectedTariff(e.target.value); 
        GetEstimatedFare();
    }} 
            value={SelectedTariff}><option value="-1">Select Tariff</option>
                    {Tariff ? (
                      Tariff.map((city, index) => (
                        <option key={index} value={city.ID}>
                          {city.TariffName}
                        </option>
                      ))
                    ) : (
                      <option>No Tariff Found </option>
                    )}
                  </select>{<p style={{"height":"0px"}} className="text-danger">{formErrors.SelectedTariff}</p>}
                </div>
              <div
                className="bookingcontainer"
                style={{
                  border: "1px solid #ccc",
                  padding: "20px",
                  borderRadius: "5px",
                  backgroundColor: "#F8F8F8",
                  marginTop: "30px",
                }}
              >
                <div className="container">
                  <div className="form-group">
                    <label style={{ fontWeight: "400" }} className="text-muted">Pickup</label>
                    {/* <input type="text" className="form-control" placeholder="Pickup Location" /> */}
                    <Autocomplete
                      onPlaceChanged={onPlaceChangedFrom}
                      onLoad={onLoadFrom}
                    >
                      <input
                        onChange={handChange}
                        name="PickupAddress"
                        type="text"
                        id="PickupAddress"
                        placeholder="Enter Pickup Location"
                        className="text-muted"
                        style={{
                          width: "100%", // Full-width for responsiveness
                          height: "40px",
                          padding: "8px 12px",
                          borderRadius: "5px",
                          border: "1px solid #ccc",
                          fontSize: "16px",
                          backgroundColor: "#f9f9f9",
                          transition: "border-color 0.3s",
                          outline: "none",
                          boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
                        }}
                        onFocus={(e) =>
                          (e.target.style.borderColor = "#007bff")
                        } // Highlight border on focus
                        onBlur={(e) => (e.target.style.borderColor = "#ccc")} // Reset border on blur
                      />
                    </Autocomplete>{<p style={{"height":"0px"}} className="text-danger">{formErrors.PickupAddress}</p>}
                  </div>
                  <div className="form-group">
                    <label style={{ fontWeight: "400" }} className="text-muted">Drop</label>
                    {/* <input type="text" className="form-control" placeholder="Drop Location" /> */}
                    <Autocomplete
                      onPlaceChanged={onPlaceChangedTo}
                      onLoad={onLoadTo}
                    >
                      <input className="text-muted"
                        onChange={handChange}
                        name="DropOffAddress"
                        type="text"
                        placeholder="To Location"
                        id="dropAddress"
                        style={{
                          width: "100%", // Full-width for responsiveness
                          height: "40px",
                          padding: "8px 12px",
                          borderRadius: "5px",
                          border: "1px solid #ccc",
                          fontSize: "16px",
                          backgroundColor: "#f9f9f9",
                          transition: "border-color 0.3s",
                          outline: "none",
                          boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
                        }}
                        onFocus={(e) =>
                          (e.target.style.borderColor = "#007bff")
                        } // Highlight border on focus
                        onBlur={(e) => (e.target.style.borderColor = "#ccc")} // Reset border on blur
                      />
                    </Autocomplete>{<p style={{"height":"0px"}} className="text-danger">{formErrors.DropOffAddress}</p>}
                  </div>

                  <div
                    className="form-group d-flex flex-column justify-content-center align-items-center"
                    style={{ gap: "1rem" }}
                  >
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ gap: "2rem" }}
                    >
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="bookingOption"
                          id="bookNow"
                          value="bookNow"
                          checked={bookingOption === "Book Now"}
                          onChange={() => {
                            setBookingOption("Book Now");
                            setShowCalendar(false);
                            setConfirmedDate(null);
                          }}
                        />
                        <label className="form-check-label" htmlFor="bookNow">
                          Book Now
                        </label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="bookingOption"
                          id="bookLater"
                          value="bookLater"
                          checked={bookingOption === "Book Later"}
                          onChange={() => {
                            setBookingOption("Book Later");
                            setShowCalendar(true);
                          }}
                        />
                        <label className="form-check-label" htmlFor="bookLater">
                          Book Later
                        </label>
                      </div>
                    </div>

                    {showCalendar && (
                      <>
                        {/* Overlay to block interaction */}
                        <div
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0, 0, 0, 0.3)",
                            zIndex: 9998,
                            pointerEvents: "auto",
                          }}
                        />

                        {/* Calendar modal */}
                        <div
                          style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            backgroundColor: "white",
                            padding: "20px",
                            borderRadius: "10px",
                            zIndex: 9999,
                            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                          }}
                        >
                          {/* Close button */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <button
                              className="btn btn-sm"
                              onClick={() => setShowCalendar(false)}
                              style={{
                                background: "none",
                                border: "none",
                                fontSize: "1.2rem",
                                fontWeight: "bold",
                                color: "#999",
                                cursor: "pointer",
                              }}
                            >
                              ✕
                            </button>
                          </div>

                         <DatePicker
  selected={selectedDate}
  onChange={(date) => setSelectedDate(date)}
  showTimeSelect
  timeIntervals={10}
  timeFormat="hh:mm aa"
  dateFormat="dd MMMM yyyy, h:mm aa"
  inline
  minDate={new Date()}

  minTime={
    selectedDate?.toDateString() === new Date().toDateString()
      ? new Date(new Date().getTime() + 3 * 60 * 60 * 1000)
      : new Date().setHours(0, 0, 0, 0)
  }

  maxTime={new Date().setHours(23, 59, 59)}
/>

                          <div className="d-flex justify-content-center mt-2">
                            <button
                              className="btn"
                              style={{
                                backgroundColor: "#70B92F",
                                color: "white",
                                border: "none",
                                padding: "0.5rem 1.5rem",
                                fontWeight: "bold",
                                borderRadius: "5px",
                              }}
                              disabled={
                                !selectedDate ||
                                isNaN(new Date(selectedDate).getTime())
                              }
                              onClick={() => {
                                setConfirmedDate(selectedDate);
                                setShowCalendar(false);
                              }}
                            >
                              Confirm
                            </button>
                          </div>
                        </div>
                      </>
                    )}

                    {confirmedDate && bookingOption === "Book Later" && (
                      <div
                        className="mt-3 d-flex justify-content-center align-items-center"
                        style={{ gap: "0.5rem" }}
                      >
                        <div className="fw-bold text-center">
                          Scheduled Date –{" "}
                          {confirmedDate.toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </div>
                        <button
                          className="btn btn-sm"
                          style={{
                            backgroundColor: "#ffe6e6",
                            color: "#e74c3c",
                            border: "none",
                            borderRadius: "50%",
                            width: "32px",
                            height: "32px",
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onClick={() => {
                            setConfirmedDate(null);
                            setSelectedDate(null);
                            setBookingOption("Book Now"); // Optional: switch back to Book Now
                          }}
                        >
                          <FaTrashAlt size={14} />
                        </button>
                      </div>
                    )}
                  </div>

                  <div
                    className="form-group d-flex justify-content-center align-items-center"
                    style={{ gap: "2rem" }}
                  >
                    <p id="calculated_distance"
                      className="mb-0 px-3 py-2"
                      style={{ backgroundColor: "white", borderRadius: "5px" }}
                    >
                      0 km Estimated Distance
                    </p>
                    <p id="calculated_Fare"
                      className="mb-0 px-3 py-2"
                      style={{ backgroundColor: "white", borderRadius: "5px" }}
                    >
                      ₹0 Estimated Fare
                    </p>
                  </div>

                  <div className="d-flex justify-content-center align-items-center">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "#1C4481",
                        borderColor: "#1C4481",
                      }}
                      onClick={(e) => {
                        e.preventDefault(); // prevent form submission if needed
                        handleSubmit(e);
                      }}
                    >
                      BOOK RIDE
                    </button>
                    {showToast && (
                      <>
                        <div
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0, 0, 0, 0.3)",
                            zIndex: 9998,
                          }}
                        />
                        <div
                          style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            backgroundColor: "white",
                            padding: "30px",
                            borderRadius: "20px",
                            zIndex: 9999,
                            textAlign: "center",
                            width: "90%",
                            maxWidth: "400px",
                            boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
                          }}
                        >
                          <button
                            onClick={() => setShowToast(false)}
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              background: "#f28b82",
                              border: "none",
                              color: "white",
                              fontSize: "1.2rem",
                              borderRadius: "50%",
                              width: "30px",
                              height: "30px",
                              cursor: "pointer",
                            }}
                          >
                            ✕
                          </button>
                          <img
                            src="https://img.icons8.com/emoji/96/000000/check-mark-emoji.png"
                            alt="Success"
                            style={{ width: "60px", marginBottom: "15px" }}
                          />
                          <h4 style={{ fontWeight: "700" }}>
                            Ride Booked successfully!
                          </h4>
                          <p>We will confirm your ride shortly</p>
                          <button
                            onClick={() => {
                              setShowToast(false);
                              navigate("/upcoming-trips");
                            }}
                            style={{
                              backgroundColor: "#1C4481",
                              color: "white",
                              padding: "10px 30px",
                              border: "none",
                              borderRadius: "8px",
                              marginTop: "15px",
                            }}
                          >
                            OK
                          </button>
                          
                        </div>
                      </>
                    )}
                  </div>
                  
{/* <div>
    <button 
  type="button"  // Important to avoid form submission
  onClick={(e) => {
    e.preventDefault(); // Prevent page reload
    handleCreateOrder(100, 'INR');
  }}
>
  Place Order
</button>
      
    </div> */}

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* </div> */}
      <div>
        <Footer />
      </div>
    </>
  );
}
export default Booking;
